<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';

export default {
	extends: Base,
  	data(){
	    return {
			Name:"BoTrxClient",
			row: {contact_person:[]},
			MrSalutation: {},
			business_prospect: {},
			total_client: '',
			total_client_range: '',
			filter_range_date: '',
			detail: '',
			total_status_client: '',
			total_status_prospect: '',
			total_status_reject: '',
			input_modal:{},
			detail_modal:{},
	    }
  	},
  	mounted(){
    	this.$set(this.$root, 'page', this)
		this.refreshData()
	},
	methods:{
		changeBP: function(v){
			this.detail_modal = v
			// alert(v.id)
			$("#changeBP").modal();
			setTimeout(()=>{

				this.$set(this.input_modal, 'mc_bp', v.mc_bp)
				this.$set(this.input_modal, 'client_id', v.mc_id)
			}, 500);
		},
		submitBP(e, callback){
			if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'editBP', id:this.input_modal.client_id}, this.input_modal),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 500).then(()=>{
		          	$("#changeBP").modal("hide");
		          	this.detail_modal.mc_bp = resp.statusBP
		          })
		        }
			},'POST')
		},
		openDetail: function(v){
			$("#detailClient").modal();
			BOGen.apirest("/"+this.Name,{type:'detail', id:v.id},(e,resp)=>{
				if(e) return console.log(e);
				this.detail = resp;
			},'POST')
        },
        onRefershPage: function(resp){
        	setTimeout(()=>{
        		this.$set(this.row, 'mc_join_date', moment().format("MM/DD/YYYY"));
        	}, 1000);
        },
	},
  	watch:{
	    '$route.query'(v){ this.refreshData() },
  	}
}
</script>

<template>
	<div class="container-fluid">
		<PageTitle></PageTitle>
		
		<!-- ======================================================================== 
			LIST DATA
		============================================================================= -->
		<div class="panel panel-flat" v-if="!$route.params.id">
			<div class="panel-body panel-filter">
				<VForm @resp="search" id="form_budget">
					<div class="row">
						<div class="col-sm-3">
							<h3 class="box-title">{{ObjectName}} List 
								<!-- <span v-if="data.total">({{(data.total||0).format()}})</span> -->
							</h3>
						</div>
						<div class="col-sm-1"></div>
						<div class="col-sm-4">
							<div class="input-group">
								<div class="input-group-addon"><span class="ti-calendar"></span></div>
		                      	<DateRangePicker v-model="filter.rangeDate" placeholder="Range Date"></DateRangePicker>
		                    </div>
						</div>
						<div class="col-sm-3">
							<div class="has-feedback has-feedback-left">
								<input type="search" v-model="filter.search" class="form-control" placeholder="Type and hit Enter">
								<div class="form-control-feedback">
									<i class="icon-search4 text-size-base text-muted"></i>
								</div>
							</div>
						</div>
						<div class="col-sm-1">
							<router-link :to="{name:Name}" class="btn btn-warning">Reset</router-link>
						</div>
					</div>
				</VForm>
			</div>
			<div class="panel-body">
				<div class="row">
			        <div class="col-md-3">
			            <div class="panel_box table-responsive">
			                <h3>Resume</h3>
			                <table class="table">
			                     <tbody>
			                        <tr>
			                            <td>Total Client</td>
			                            <td><strong>{{ total_client }}</strong></td>
			                        </tr>
			                    </tbody>
			                </table>
			            </div>
			        </div>
			        <div class="col-md-5" v-if="filter.rangeDate">
			            <div class="panel_box table-responsive">
			                <h3>Resume by Range</h3>
			                <table class="table">
			                     <tbody>
			                        <tr>
			                            <td>Total Client {{ filter_range_date }}</td>
			                            <td><strong>{{ total_client_range }}</strong></td>
			                        </tr>
			                    </tbody>
			                </table>
			            </div>
			        </div>
			        <div class="col-md-4">
			            <div class="panel_box table-responsive">
			                <h3>Resume Client/Prospect</h3>
			                <table class="table">
			                     <tbody>
			                        <tr>
			                            <td>Client</td>
			                            <td><strong>{{ total_status_client }}</strong></td>

			                            <td>Prospect</td>
			                            <td><strong>{{ total_status_prospect }}</strong></td>

			                            <td>Reject</td>
			                            <td><strong>{{ total_status_reject }}</strong></td>
			                        </tr>
			                    </tbody>
			                </table>
			            </div>
			        </div>
			    </div>
			</div>
			<div class="table-responsive ajax-table">
				<table class="table table-hover table-bordered">
					<thead>
						<tr>
							<th>#</th>
							<th><SortField name="mc_comp_name"></SortField></th>
							<th>{{ fields.mc_name }}</th>
							<th>{{ fields.mc_code }}</th>
							<th>Contact</th>
							<th>PIC</th>
							<th>BP</th>
							<th width="140px">Action</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(v,k) in data.data" :key="k">
							<td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
							<td>
								{{v.mc_comp_name}}<br>
								<span class="label label-sm no_radius" :style="'background:#'+v.color_mc_initial">{{ v.mc_initial }}</span>
							</td>
							<td>
								<a class="btn_copy" v-clipboard:copy="v.mc_code" v-tooltip="'Copy Client ID'">
									{{v.mc_name}}
								</a>
							</td>
							<td>{{v.mc_code}}</td>
							<td>
								<strong>Address:</strong> {{ v.mc_comp_address ? v.mc_comp_address : '-' }}<br>
								<strong>Phone:</strong> {{ v.mc_phone ? v.mc_phone : '-' }}<br>
								<strong>Web:</strong> {{ v.mc_url ? v.mc_url : '-' }}
							</td>
							<td>
								<span v-for="(v2,k2) in v.contact_person">
									<strong>Name:</strong> {{ v2.fullname }}<br>
									<strong>Position:</strong> {{ v2.mcc_position ? v2.mcc_position : '-' }} <br>
								</span>
							</td>
							<td>
								<a href="javascript:;" @click="changeBP(v)">
									<StatusLabel :status="v.mc_bp" type="business-prospect" style="cursor: pointer;"></StatusLabel>
								</a>
							</td>
							<td class="btn-action text-center">
								<a href="javascript:;" class="icon_action" @click="openDetail(v)" v-tooltip="'View Detail'"><i class="fa fa-eye"></i></a>

								<router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="icon-pencil"></i></router-link>
								<!-- <a href="javascript:;" class="icon_action" @click="changeStatus(k)" v-tooltip="'Change Status'"><i class="icon-settings"></i></a> -->

								<a v-if="v.count_relation==0" href="javascript:;" class="icon_action" @click="deleteItem($event,k)" v-tooltip="'Remove'"><i class="icon-trash"></i></a>
								<a v-if="v.count_relation>0" href="javascript:;" class="icon_action" @click="relatedDeleteItem($event,k)" v-tooltip="'Remove'"><i class="icon-trash"></i></a>
							</td>
						</tr>
						<tr v-if="NotFound">
							<td colspan="99">
								<h3 class="tc">{{NotFound}}</h3>
							</td>
						</tr>
						<tr v-if="data.data===false">
							<td colspan="99">
								<LoadingSpinner light></LoadingSpinner>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="panel-body">
				<div class="pull-right">
					<Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
				</div>
			</div>
		</div>

		<!-- Modal -->
		<VModal name="changeBP" title="Change Business/Prospect" sizeModal="modal-md" method="post" noFooter @resp="submitBP">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<label class="">Status <span class="text-danger">*</span></label>
				</div>
				<div class="col-sm-6">
					<input type="hidden" v-model="input_modal.client_id">
					<select2 name="mc_bp" v-bind="validation('mc_bp')" :options="business_prospect" v-model="input_modal.mc_bp" class="form-control">
						<option value="">-- Select Status --</option>
					</select2>
				</div>
			</div>
			<div class="modal-footer" style="margin-top: 10px;">
				<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>
		<VModal name="detailClient" title="Detail Client" method="post" noFooter>
			<table class="table">
				<tbody>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Client Name</h4>
								<p>
									{{ detail.mc_name }}<br>
									<span class="label label-sm no_radius" :style="'background:#'+detail.color_initial">{{ detail.mc_initial }}</span>
								</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Company Name</h4>
								<p>
									{{ detail.mc_comp_name }}<br>
									<strong>ID:</strong> {{ detail.mc_code }}
								</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Join Date</h4>
								<p>{{ detail.join_date }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Address</h4>
								<p>{{ detail.mc_comp_address ? detail.mc_comp_address : '-' }}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Phone</h4>
								<p>{{ detail.mc_phone ? detail.mc_phone : '-' }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>URL</h4>
								<p>{{ detail.mc_url ? detail.mc_url : '-' }}</p>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<h4 style="margin-top:25px">Contact Person</h4>
			<table class="table table-bordered">
				<thead>
					<tr>
						<th class="lbl_popup">Fullname</th>
						<th class="lbl_popup">Email</th>
						<th class="lbl_popup">Phone Number</th>
						<th class="lbl_popup">Position</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(v,k) in detail.contact_person">
						<td>{{ v.fullname }}</td>
						<td>{{ v.mcc_email ? v.mcc_email : '-' }}</td>
						<td>{{ v.mcc_phone ? v.mcc_phone : '-' }}</td>
						<td>{{ v.mcc_position ? v.mcc_position : '-' }}</td>
					</tr>
				</tbody>
			</table>
		</VModal>

		<!-- ======================================================================== 
			FORM CRUD	
		============================================================================= -->
		<div class="panel panel-flat" v-if="$route.params.id">
			<VForm @resp="submitForm" method="post">
				<div class="panel-heading">
					<h2 class="panel-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h2>
				</div>	
				<div class="panel-body">
					<div class="info"></div>
					<div class="row">
						<div class="col-sm-6">
							<BoField name="mc_name" v-model="row.mc_name"></BoField>
							<BoField name="mc_initial" v-model="row.mc_initial" :attr="{class:'input_capitalize'}"></BoField>
							<BoField name="mc_join_date">
								<div class="input-group">
			                      	<DatePicker name="mc_join_date" v-model="row.mc_join_date" v-bind="validation('mc_join_date')"></DatePicker>
			                      	<div class="input-group-addon"><span class="ti-calendar"></span></div>
			                    </div>
							</BoField>
							<BoField name="mc_comp_address">
								<textarea name="mc_comp_address" rows="4" class="form-control" v-model="row.mc_comp_address" v-bind="validation('mc_comp_address')"></textarea>
							</BoField>							
						</div>
						<div class="col-sm-6">
							<BoField name="mc_comp_name" v-model="row.mc_comp_name"></BoField>
							<BoField name="mc_phone" v-model="row.mc_phone" keyFilter="phoneKey"></BoField>
							<BoField name="mc_url" v-model="row.mc_url"></BoField>	
							<BoField name="mc_bp" v-model="row.mc_bp">
								<select2 name="mc_bp" v-bind="validation('mc_bp')" :options="business_prospect" v-model="row.mc_bp" class="form-control">
									<option value="">-- Select Status --</option>
								</select2>
							</BoField>
						</div>
						<div class="col-xs-12">
							<h3>Contact Person</h3>
							<table class="table table-bordered">
								<thead>
									<tr>
										<th colspan="10" class="text-right" style="border: 1px solid transparent;">
											<button type="button" class="btn btn-primary" @click="row.contact_person.push({})">Add Contact Person</button>
										</th>
									</tr>
									<tr>
										<th class="lbl_popup">Salutation <span class="text-danger">*</span></th>
										<th class="lbl_popup">Fullname <span class="text-danger">*</span></th>
										<th class="lbl_popup">Email</th>
										<th class="lbl_popup">Phone Number</th>
										<th class="lbl_popup">Position</th>
										<th class="lbl_popup" v-if="row.contact_person.length>1"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(v,k) in row.contact_person">
										<td>
											<select2 :options="MrSalutation" v-model="v.mcc_salutation" class="form-control">
												<option value="">Salutation</option>
											</select2>
											<input type="hidden" v-model="v.mcc_id" v-if="row.id">
										</td>
										<td>
											<input type="text" v-model="v.mcc_name" class="form-control" required="">
										</td>
										<td>
											<input type="email" v-model="v.mcc_email" class="form-control">
											<span error="v.mcc_email"></span>
										</td>
										<td>
											<input type="text" v-model="v.mcc_phone" class="form-control" onkeypress="return phoneKey(event)">
										</td>
										<td>
											<input type="text" v-model="v.mcc_position" class="form-control">
										</td>
										<td v-if="row.contact_person.length>1">
											<button type="button" class="btn btn-danger" @click="row.contact_person.length>1 ? row.contact_person.splice(k,1) : ''"><i class="icon-trash"></i></button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="col-xs-12">
							<div class="text-right">
								<button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
							</div>
						</div>
					</div>
				</div>
			</VForm>
		</div>
	</div>
</template>
